// Import icons
import CreditCard from '@/assets/img/payment-types/card-v2.svg';
import DebitCard from '@/assets/img/payment-types/card-v2.svg';
import BoletoIcon from '@/assets/img/payment-types/boleto-v2.svg';
import PixIcon from '@/assets/img/payment-types/pix-v2.svg';
import PaymentTypes from '@/models/PaymentTypes';
import QrCodePay from '@/assets/img/payment-types/qrcode-v2.svg';
import VoucherCard from '@/assets/img/payment-types/card-v2.svg';
import MultiCard from '@/assets/img/payment-types/multi-card.svg';
import PixOpenFinanceIcon from '@/assets/img/payment-types/pix-open-finance.svg';

export default {
    namespaced: true,

    state: {
        Types: [
            {
                Id: PaymentTypes.CREDIT_CARD,
                Title: 'Cartão de crédito',
                Icon: CreditCard,
                Available: true,
                StartView: 'CardDataCred',
                Text: 'creditCardText'
            },
            {
                Id: PaymentTypes.DEBIT_CARD,
                Title: 'Cartão de débito',
                Icon: DebitCard,
                Available: true,
                StartView: 'CardDataDebit',
                Text: 'debitCardText'
            },
            {
                Id: PaymentTypes.BOLETO,
                Title: 'Boleto Bancário',
                Icon: BoletoIcon,
                Available: true,
                StartView: 'PersonalData',
                Text: ''
            },
            {
                Id: PaymentTypes.PIX,
                Title: 'Pix',
                Icon: PixIcon,
                Available: true,
                StartView: 'PersonalData',
                Text: 'pixText',
                PixTypeIcon: PixIcon,
                PixTypeTitle: 'Pix',
                PixTypeText: 'pixTypePixText',
                PixTypeStartView: 'PersonalData',
                Badge: '',
            },
            {
                Id: PaymentTypes.PIX_OPEN_FINANCE,
                Title: 'Pix via Open Finance',
                Icon: PixOpenFinanceIcon,
                Available: true,
                StartView: 'PixOpenFinanceBanksList',
                Text: 'pixText',
                PixTypeIcon: PixOpenFinanceIcon,
                PixTypeTitle: 'Pix via Open Finance',
                PixTypeText: 'pixTypeOpenFinanceText',
                PixTypeStartView: 'PixOpenFinanceBanksList',
                Badge: 'recommendedBadge',
            },
            {
                Id: PaymentTypes.QRCODE,
                Title: 'QR Code Crédito',
                Icon: QrCodePay,
                Available: true,
                StartView: 'QrCodePayInstallments',
                Text: 'qrCodePayText'
            },
            {
                Id: PaymentTypes.VOUCHER,
                Title: 'Alimentação / Refeição',
                Icon: VoucherCard,
                Available: true,
                StartView: 'CardDataVoucher',
                Text: ''
            },
            {
                Id: PaymentTypes.QRCODE_DEBIT,
                Title: 'QR Code Débito',
                Icon: QrCodePay,
                Available: true,
                StartView: 'PersonalData',
                Text: 'qrCodeDebitText'
            },
            {
                Id: PaymentTypes.MULTIBENEFITS,
                Title: 'Cartão multibenefícios',
                Icon: MultiCard,
                Available: true,
                StartView: 'CardDataMultibenefits',
                Text: ''
            },
            
        ],

        /**
         * Payment types that are mapped from the preorder get response.
         */
        TypesFromPreorder: []
    },

    mutations: {
        /**
         * Map the api response to the module
         */
        setFromRequest(state, data) {
            state.TypesFromPreorder = data;
        }
    },

    getters: {
        /**
         * Retorna todos os tipos de pagamento
         */
        getAll: state => state.Types,

        /**
         * Retorna os tipos de pagamento disponíveis para a loja
         * 
         * Obs:
         * Caso o pagamento não seja por crédito nem débito, precisamos
         * retornar também o id do meio de pagamento, já que nos pagamentos
         * por catão, o id do meio de pagamento vem pela consulta bin, e
         * como nesses outros meios de pagamento não existe essa consulta,
         * o id precisa ser retornado na hora da seleção, para que o módulo
         * da storage possa saber o id na hora do processamento.
         */
        getAvailable: (state, getters, rootState) => {
            const types = state.Types.filter(paymentType =>
                rootState.payment.PaymentMethods.some(
                    paymentMethod => paymentMethod.PaymentType == paymentType.Id
                )
            ).map(paymentType => {
                const isCreditOrDebit =
					          paymentType.Id == PaymentTypes.CREDIT_CARD ||
                    paymentType.Id == PaymentTypes.DEBIT_CARD ||
                    paymentType.Id == PaymentTypes.VOUCHER ||
                    paymentType.Id == PaymentTypes.MULTIBENEFITS ||
                    paymentType.Id == PaymentTypes.GOOGLE_PAY ||
                    paymentType.Id == PaymentTypes.APPLE_PAY;
                    
                const paymentMethod =
					rootState.payment.PaymentMethods.find(
					    paymentMethod =>
					        paymentMethod.PaymentType == paymentType.Id
					);
                    
                const preorderPaymentType = state.TypesFromPreorder.find(
                    preorderPaymentType => {
                        return preorderPaymentType.Type == paymentType.Id;
                    }
                ) || {};
                
                return {
                    ...paymentType,
                    paymentMethodId:
                        isCreditOrDebit === false 
                        && paymentMethod
                        && (paymentMethod.Id || null),
                    discount: preorderPaymentType.Discount
                };
            });

            return types;
        },

        /**
         * Retorna os tipos de pagamento disponíveis, removendo PIX_OPEN_FINANCE se PIX também existir
         */
        getFilteredAvailable: (state, getters) => {
            let types = getters.getAvailable;
      
            const hasPix = types.some(type => type.Id === PaymentTypes.PIX);
            const hasPixOpenFinance = types.some(type => type.Id === PaymentTypes.PIX_OPEN_FINANCE);
      
            if (hasPix && hasPixOpenFinance) {
                types = types.filter(type => type.Id !== PaymentTypes.PIX_OPEN_FINANCE);
            }
      
            return types;
        },
    
        /**
         * Retorna apenas os tipos de pagamento PIX e PIX_OPEN_FINANCE do getter getAvailable
         */
        getPixTypes: (state, getters) => {
            return getters.getAvailable.filter(type =>
                type.Id === PaymentTypes.PIX || type.Id === PaymentTypes.PIX_OPEN_FINANCE
            );
        }
    }
};
